import {
  ArrowDownCircleOutline,
  ArrowUpCircleOutline,
  PhonePortraitOutline,
} from "@raresail/react-ionicons";
import { openModalForm } from "../../utils/modalUtils";
import {
  NEW_MANUAL_DEPOSIT,
  NEW_MANUAL_WITHDRAWAL,
  TOP_UP,
  WITHDRAW,
} from "../../constants/constants";

type Method = {
  label: string;
  description: string;
  icon: any;
  onClick: () => void;
};

/**
 * Bottom-sheet picker for top-up / withdraw method selection.
 * Renders a list of methods (Mobile Money, Bank). Invoked via
 * openBottomSheet({ component: "method_picker", source: TOP_UP|WITHDRAW }).
 */
export const MethodPicker = ({
  dismiss,
  source,
}: {
  dismiss?: () => void;
  source?: string;
}) => {
  const isWithdraw = source === WITHDRAW;
  const title = isWithdraw ? "Withdraw" : "Top Up";

  const methods: Method[] = isWithdraw
    ? [
        {
          label: "Mobile Money",
          description: "Send to your registered mobile money number",
          icon: PhonePortraitOutline,
          onClick: () => {
            dismiss?.();
            openModalForm({ source: WITHDRAW });
          },
        },
        {
          label: "Bank Transfer",
          description: "Withdraw to a Ugandan bank account",
          icon: ArrowUpCircleOutline,
          onClick: () => {
            dismiss?.();
            openModalForm({ source: NEW_MANUAL_WITHDRAWAL });
          },
        },
      ]
    : [
        {
          label: "Mobile Money",
          description: "Top up instantly from your mobile money",
          icon: PhonePortraitOutline,
          onClick: () => {
            dismiss?.();
            openModalForm({ source: TOP_UP });
          },
        },
        {
          label: "Bank Deposit",
          description: "Deposit from your bank account (with proof of payment)",
          icon: ArrowDownCircleOutline,
          onClick: () => {
            dismiss?.();
            openModalForm({ source: NEW_MANUAL_DEPOSIT });
          },
        },
      ];

  return (
    <div
      className="whiteBg flexColumn gap10"
      style={{ padding: 20, paddingBottom: 30, maxWidth: 480, width: "100%", margin: "0 auto" }}
    >
      <div className="bold font18 textDark mb10">Choose {title} Method</div>
      {methods.map((m) => {
        const Icon = m.icon;
        return (
          <button
            key={m.label}
            onClick={m.onClick}
            className="r10 animate flexNullCenter gap15"
            style={{
              padding: 15,
              border: "1px solid #eee",
              background: "#fafafa",
              cursor: "pointer",
              textAlign: "left",
              width: "100%",
            }}
          >
            <div
              className="flexCenter r10"
              style={{
                width: 44,
                height: 44,
                background: "#fff",
                border: "1px solid #eee",
                flexShrink: 0,
              }}
            >
              <Icon fontSize={22} />
            </div>
            <div className="flexColumn gap5" style={{ flex: 1 }}>
              <div className="semiBold font14 textDark">{m.label}</div>
              <div className="font12 grey">{m.description}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
};
